import React from 'react'
import { connect } from 'react-redux'

export default function isAuthenticatedContainer (Component) {
	class AuthenticatedComponent extends React.Component {

		handleAuthentication (props) {
			const { isAuthenticated } = props

			if (!isAuthenticated) props.history.push('/')
		}

		componentWillMount () {
			this.handleAuthentication(this.props)
		}

		componentWillReceiveProps (nextProps) {
			this.handleAuthentication(nextProps)
		}

		render () {
			const { isAuthenticated } = this.props

			if (!isAuthenticated) return null

			return <Component {...this.props} />
		}
	}
	const mapStateToProps = (state) => ({
		isAuthenticated: state.auth.token
	})

	return connect(mapStateToProps)(AuthenticatedComponent)
}



// WEBPACK FOOTER //
// ./src/containers/AuthHOC.js